import * as React from "react";
import { Tooltip } from "antd";
import { IconButton } from "src/components/buttons";
import { Info, Trash2, CirclePlus } from "lucide-react";
import { Icon } from "src/components/icons/Icon";

import DropdownInputAnt from "src/components/forms/DropdownInputAnt";

import PickListContext from "src/context/pickListContext";

import Dropdown from "src/components/forms/Dropdown";

interface IOption {
	key: string;
	label: string;
}

interface IState {
	count: number | undefined;
	chosenError: IOption;
}

interface IProps {
	error: CoreErrorEntryDTO;
	addErrorToList: (error: IOption, count: number, errorId: number) => void;
	removeErrorFromList: (errorEntryId: number, errorValueId: number) => void;
	addErrorScore: (e: any, id: number) => void;
	fleetErrors: FleetErrorDTO[];
	dataLocked?: boolean;
}

class ErrorComponent extends React.Component<IProps, IState> {
	public static contextType = PickListContext;
	public constructor(props: IProps) {
		super(props);
		this.state = {
			count: undefined,
			chosenError: {} as IOption,
		};
	}

	public render() {
		const { error, dataLocked } = this.props;
		const { count, chosenError } = this.state;

		const fleetOptions = this.setFleetErrorOptions(
			this.props.error.skillCategoryId!
		);
		return (
			<div key={error.skillCategoryId}>
				<strong>{this.setErrorName()!}</strong>
				<div className="border p-3 mb-4">
					<div>
						<div className="border-bottom">
							<div className="row">
								<div className="col-6">
									<small className="ml-3 font-weight-bold text-uppercase">
										Code
									</small>
								</div>
								<div className="col-6">
									<small className="font-weight-bold text-uppercase">
										Count
									</small>
								</div>
							</div>
						</div>
						<div className="border-top">
							{error.values !== undefined && error.values.length > 0 ? (
								error.values!.map((err) => {
									return (
										<div className="border-bottom" key={err.id}>
											<div className="row align-items-center">
												<div className="col-6 py-2">
													<span className="mx-3">{err.code}</span>
													<Tooltip
														overlayClassName="mx-3"
														title={err.description}
														arrowPointAtCenter={true}
													>
														<Icon
															className="text-primary"
															icon={Info}
															badge
														/>
													</Tooltip>
												</div>
												<div className="col-4">{err.count}</div>
												<div className="col-2 p-0">
													<IconButton
														className="bg-white p-3"
														onClick={() =>
															this.props.removeErrorFromList(
																error.skillCategoryId!,
																err.id!
															)
														}
														title="Remove error"
														disabled={dataLocked}
													>
														<Icon
															className="text-primary"
															icon={Trash2}
														/>
													</IconButton>
												</div>
											</div>
										</div>
									);
								})
							) : (
								<div className="text-center text-muted py-3 border-bottom">
									No items available
								</div>
							)}
							<div className="row align-items-center pt-3">
								<div className="col-6">
									<Dropdown
										id="errorEntryValue"
										name="errorEntryValue"
										placeholder="Pick an error type"
										value={chosenError.key ? chosenError : undefined}
										options={fleetOptions}
										onChange={(e: any) => this.setErrorEntryValue(e)}
										disabled={dataLocked}
									/>
								</div>
								<div className="col-4 px-0">
									<DropdownInputAnt
										pickListCode="CountDropdownOptions"
										parentCode="CountValues"
										name="errorEntryValue"
										onChange={this.setErrorCount}
										value={count}
										placeholder="Choose a number"
										disabled={dataLocked}
									/>
								</div>
								<div className="col-2 align-middle p-0">
									<IconButton
										className="bg-white p-3"
										onClick={() =>
											this.clearValues(
												chosenError,
												count!,
												error.skillCategoryId!
											)
										}
										disabled={
											this.addDisabled(chosenError, count!) || dataLocked
										}
										title="Add error"
									>
										<Icon
											className="text-primary"
											icon={CirclePlus}
											badge
										/>
									</IconButton>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	private setErrorName = () => {
		const foundError: PickListItemResponseDTO = this.context.pickListItems.find(
			(pItem: PickListItemResponseDTO) =>
				pItem.id === this.props.error.skillCategoryId
		);
		if (foundError !== undefined) {
			return foundError.description;
		}

		return "";
	};

	private addDisabled = (chosenError: IOption, count: number) => {
		const isEmpty = Object.keys(chosenError).length === 0 ? true : false;
		if (count === undefined && isEmpty) {
			return true;
		}

		if (count === undefined) {
			return true;
		}

		if (isEmpty) {
			return true;
		}

		return false;
	};

	private setFleetErrorOptions = (categoryId: number) => {
		const fleetErrorOptions =
			this.props.fleetErrors.length > 0
				? this.props.fleetErrors
						.filter((fleet) => fleet.skillCategory === categoryId)
						.map((err) => ({
							key: err.id!.toString(),
							label: `${err.errorCode}.${err.description}`,
						}))
				: [];

		return fleetErrorOptions as IOption[];
	};

	private clearValues = (option: IOption, count: number, errorId: number) => {
		this.props.addErrorToList(option, count, errorId);
		this.setState({ chosenError: { key: "", label: "" }, count: undefined });
	};

	private setErrorCount = (e: any) => {
		const value = e.key;
		this.setState({ count: value });
	};

	private setErrorEntryValue = (e: any) => {
		const option = e;
		this.setState({ chosenError: option });
	};
}
export default ErrorComponent;
